var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "category-sidebar"
  }, [_c('div', {
    staticClass: "category-sidebar__filter-wrapper"
  }, [_vm._l(_vm.list, function (group) {
    return [group.isMain && group.type === 'checkbox' ? _c('div', {
      key: group.id,
      staticClass: "category-sidebar__block"
    }, [_c('h3', {
      staticClass: "fz-21 lh-24 b"
    }, [_vm._v("\n          " + _vm._s(group.name) + "\n        ")]), _vm._v(" "), group.filter ? _c('div', {
      staticClass: "category-sidebar__filter-list"
    }, [_c('div', {
      staticClass: "category-sidebar__filter"
    }, [_c('ShowHiddenList', {
      attrs: {
        "items": group.filter.length
      },
      scopedSlots: _vm._u([{
        key: "item",
        fn: function () {
          return _vm._l(group.filter, function (filter, index) {
            return _c('div', {
              key: index,
              staticClass: "category-sidebar__filter-prop-item"
            }, [_c('nuxt-link', {
              staticClass: "link link_wu fz-13 lh-17",
              attrs: {
                "to": ("filter/?" + (filter.property) + "=" + (filter.value)),
                "title": filter.name
              }
            }, [_vm._v("\n                    " + _vm._s(filter.name) + "\n                  ")])], 1);
          });
        },
        proxy: true
      }], null, true)
    })], 1)]) : _vm._e()]) : _vm._e()];
  })], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }